import React, {useEffect, useState} from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useParams, useLocation, useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {fetchScheduleInfo, updateScheduleInfo} from "redux/slices/schedule/scheduleSlice";

import {
	getScheduleType, getScheduleTypeName,
	getScheduleCancelName, getScheduleCancelColor, getScheduleCancelPathName,
	getServiceKindName, getUseNumber
} from "utils/define";
import {getToday} from "utils/date";

import MainLayout from "layouts/MainLayout";
import Button from "components/ui/Button";
import SummaryInfo from "./SummaryInfo";
import ReservationList from "./ReservationList";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [스케줄 상세]
 */

export const ScheduleInfo = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {serviceType, sequence} = useParams();
	let {data, isLoading, isError} = useSelector(state => state.schedule.scheduleInfo);
	if(!data) data = {};

	const scheduleType = getScheduleType(data).toLowerCase();
	const scheduleState = data.scheduleState;

	useEffect(() => {
		eventHandler.update();
	}, []);

	const eventHandler = {
		update : () => {
			dispatch(updateScheduleInfo({
				serviceType : serviceType,
				sequence : sequence
			}));
		},
		refresh : () => {
			eventHandler.update();
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					resolve();
				}, 700);
			});
		}
	};



	const render = () => {
		const getTitle = () => {
			const scheduleTypeName = getScheduleTypeName(scheduleType, "kr");
			return (scheduleType) ? `${scheduleTypeName} 스케줄` : `스케줄 상세 보기`;
		};

		const getDateInfo = () => {
			const startDate = new Date(data.startDate);
			const endDate = new Date(data.endDate);
			const scheduleDate = startDate.format("sm. sd. sw");
			const startTime = startDate.format("ap hh:MM");
			const endTime = endDate.format("ap hh:MM");
			const isToday = (getToday() == startDate.getCalendar());
			return (
				<div className="dateInfo">
					<div className="left">
						<b>{scheduleDate}</b>
						{(isToday) ? <span>오늘</span> : null}
					</div>
					<div className="right">
						{startTime} - {endTime}
					</div>
				</div>
			);
		};

		const getReservationInfo = () => {
			const countInfo = data.classScheduleMemberCount;
			return (scheduleType == "class" && scheduleState != "C" && scheduleState != "O") ? ( // 취소나 폐강 아닐떄 보여준다
				<div className="reservationInfo color">
					<ul>
						<li className="blue">예약 {countInfo.reservationCount}</li>
						<li className="green">출석 {countInfo.attendanceCount}</li>
						<li className="red">결석 {countInfo.absenceCount}</li>
						{(data.waitableLimitNo) ?
								<li className="darkGray">대기 {countInfo.waitCount}</li> : null}
					</ul>
				</div>
			) : null;
		};

		const getReservationList = () => {
			if(scheduleType != "class" || scheduleState == "C" || scheduleState == "O") return null;
			return ["reservation", "wait", "cancel"].map((item, index) => {
				return (<ReservationList key={index} mode={item} data={data} />);
			});
		};

		const getPassInfo = () => {
			const cancelInfo = data.cancelHistory || {};
			const getBadge = () => {
				// 취소자 구분 : 강사, 회원, 관리자
				const cancelPath = cancelInfo.cancelPath;
				const name = getScheduleCancelName(cancelPath);
				const color = getScheduleCancelColor(cancelPath);
				return <em className={"badge " + color}>{name}</em>
			};
			if(scheduleState == "C" || scheduleState == "O") {
				const cancelDate = (cancelInfo.cancelDateTime) ? new Date(cancelInfo.cancelDateTime).getFormattedDatetime() : "-";
				const cancelPath = getScheduleCancelPathName(cancelInfo.cancelPath) || "-";
				return (
					<section className="passInfo color">
					<h4 className="red">{`${scheduleState == "O" ? "폐강" : "취소"} 내역`}</h4>
						<ul>
							<li>
								<div>취소 처리자</div>
								<div>
									{getBadge()}
									{cancelInfo.coachName || cancelInfo.memberName || "-"}
								</div>
							</li>
							<li>
								<div>취소 경로</div>
								<div>{cancelPath}</div>
							</li>
							<li>
								<div>취소 일시</div>
								<div>{cancelDate}</div>
							</li>
						</ul>
					</section>
				);
			} else {
				return (scheduleType == "appointment") ? (
					<section className="passInfo">
						<h4>사용한 이용권</h4>
						<ul>
							<li>
								<div>회원명</div>
								<div>{data.memberName || "-"}</div>
							</li>
							<li>
								<div>이용권명</div>
								<div>{(data.passName || "-").recoverTag()}</div>
							</li>
							<li>
								<div>이용권 속성</div>
								<div>{getServiceKindName(data.serviceKind)}</div>
							</li>
							<li>
								<div>레슨시간</div>
								<div>{data.serviceTime}분</div>
							</li>
							<li>
								<div>이용횟수</div>
								<div>{getUseNumber(data.serviceKind, data.useNumber)}</div>
							</li>
							<li>
								<div>잔여횟수</div>
								<div>{getUseNumber(data.serviceKind, data.remainNumber)}</div>
							</li>
						</ul>
					</section>
				) : null;
			}
		};

		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : getTitle()
					}}
					withBottomTab={false}
					isLoading={isLoading}
					isError={isError}
					onRefresh={eventHandler.refresh}
				>
					<Wrapper>
						{getDateInfo()}
						<section>
							<SummaryInfo mode="info" data={data} />
							{getReservationInfo()}
						</section>
						{getPassInfo()}
						{getReservationList()}
					</Wrapper>
				</MainLayout>
			</PullToRefresh>
		);
	};

	return render();
};

const Wrapper = styled.div`
& > .middle							{padding:0 !important; background-color:var(--lightGray) !important}

section								{padding:25px; background-color:white}
section > h4						{font-size:1rem}
section + section					{margin-top:12px}

.dateInfo							{display:flex; padding:8.5px 24px; align-items:center; justify-content:space-between; font-size:var(--14px)}
.dateInfo							{background-color:var(--lightBlue); font-weight:500; color:var(--blueBlack)}
.dateInfo b							{}
.dateInfo span						{color:var(--darkGray)}
.dateInfo span:before				{content:" · "}
.dateInfo .right					{font-weight:400}

.passInfo							{}
.passInfo h4						{margin-bottom:25px}
.passInfo li						{display:flex; justify-content:space-between}
.passInfo li div					{color:var(--gray)}
.passInfo li div + div				{text-align:right; font-weight:500; color:var(--black)}
.passInfo li + li					{margin-top:12px}

.passInfo em						{vertical-align:text-bottom; margin-right:8px; padding:4px 8px; border-radius:4px; font-size:var(--12px)}
.passInfo em.blue					{background-color:rgba(0,79,236,0.1)}
.passInfo em.purple					{background-color:rgba(115,87,197,0.15)}
.passInfo em.black					{background-color:rgba(38,40,43,0.1)}

.reservationInfo					{margin-top:15px; padding:12px; border-radius:calc(var(--borderRadius) / 2); border:1px solid var(--border); font-size:var(--15px); font-weight:600}
.reservationInfo ul					{display:flex; justify-content:space-between; text-align:center}
.reservationInfo ul li				{width:100%}
`;

export default ScheduleInfo;





